import { render, staticRenderFns } from "./RetailMain.vue?vue&type=template&id=701e81f1&scoped=true&"
import script from "./RetailMain.vue?vue&type=script&lang=js&"
export * from "./RetailMain.vue?vue&type=script&lang=js&"
import style0 from "./RetailMain.vue?vue&type=style&index=0&id=701e81f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e81f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VFlex,VSpacer})
